/**
 * Select
 *
 * store dots selection
 *
 */

export default class Select {



    constructor() {

        this.unselect()

        this.debug = true

    }



    selectRemove( index ) {

        if ( this.indexes.includes(index) ) {

            var i = this.indexes.indexOf( index )
            if (i !== -1) this.indexes.splice(i, 1)

            delete this.select[ index ]

            return true
        }

        return false

    }



    selectAdd( index , dot ) {

        if (this.debug) {
            console.log( 'select : ' + index , dot )
        }

        // add index and dot data only once

        if (!this.indexes.includes(index)) {

            this.indexes.push( index )

            this.select[ index ] = {
                dot: {
                    x: dot.x,
                    y: dot.y,
                    z: dot.z
                }
            }

            return true

        } else {

            if (this.debug) {
                console.log( 'select > already selected : ' + index )
            }

            return false

        }

    }



    selectUpdate( index , x , y , z ) {

        this.select[ index ] = {
            dot: {
                x: x,
                y: y,
                z: z
            }
        }

    }



    hasSelected() {

        if (Object.keys( this.select ).length > 0)
            return true
        else
            return false

    }



    unselect() {

        this.select = {}

        this.indexes = []

    }



    getSelected() {

        return this.select

    }



    /*getDots() {

        if (!this.hasSelected()) return false

        let geometry = new THREE.BufferGeometry()


        var positions = [];

        for (let [ dotIndex, dot ] of Object.entries( this.select )) {
            console.log( dotIndex , dot  )
            //geometry.vertices.push(new THREE.Vector3( dot.x , dot.y , dot.z ))




            positions.push(dot.x ,dot.y, dot.z);

        }

        let material = new THREE.PointsMaterial( {
            size: 18,
            sizeAttenuation: true,
            color: 0xff0000,
            opacity: 0.5
        } )

        console.log(positions)

        geometry.setAttribute(
            'position',
            new THREE.Float32BufferAttribute(positions, 3)
        );
        //geometry.setAttribute('color', new THREE.Float32BufferAttribute(colors, 3));

        geometry.computeBoundingSphere();

        let dots = new THREE.Points( geometry , material )

        let group = new THREE.Group()

        group.add(dots)

        return group

    }*/



}


